import { Injectable, EventEmitter } from '@angular/core';
import { HttpHelper } from './http.service';
import { AppConfig } from '../model/config';
import { Location } from '../model/location';
import { GateStatus } from '../model/GateStatus';
import { SignalRService } from './signalr.service';

@Injectable()
export class BfsService {

  public updateGateStatus$: EventEmitter<GateStatus[]>;
  public ping$: EventEmitter<GateStatus>;

  constructor(
    private readonly http: HttpHelper,
    private readonly configuration: AppConfig,
    private readonly signalRService: SignalRService) {

    this.signalRService.gatePing$.subscribe((gateStatus: GateStatus) => { this.onGatePing(gateStatus); });
    this.signalRService.updateGateStatus$.subscribe((status: GateStatus[]) => { this.onUpdateGateStaus(status); });

    this.updateGateStatus$ = new EventEmitter<GateStatus[]>();
    this.ping$ = new EventEmitter<GateStatus>();

  }

  //Get all transfers from location
  public async getAllTransfers(airport: string): Promise<any> {

    let url: string = this.configuration.backendUrl + "/api/bustransfer/allTransfers?airport=" + airport;

    return await this.http.get(url, () => { },
      () => { }).toPromise<any>();
  }

  // Get the valid transfers points for this airport
  public async getValidTransferPoints(): Promise<any> {

    let url: string = this.configuration.backendUrl + "/api/bustransfer/gettransferpoints";

    return await this.http.get(url, () => { },
      () => { }).toPromise<any>();
  }

  public async updateTransfer(locations: Location[]): Promise<any> {

    let gateConfiguration: any[] = [];

    locations.forEach((location) => {
      let body = {
        "gate": location.name,
        "gateConfiguration": {
          "gateStatus": "Unknown",
          "requireConfirmation": false,
          "weekDayOpens": location.weekDayOpens,
          "weekDayCloses": location.weekDayCloses,
          "weekEndOpens": location.weekEndOpens,
          "weekEndCloses": location.weekEndCloses,
          "description": location.description
        }
      };

      gateConfiguration.push(body);

    });

    return this.http.post(this.configuration.backendUrl + "/api/bustransfer/UpdateGateConfiguration",
      gateConfiguration,
      (result) => { },
      (exception) => { }).toPromise<any>();
  }

  public async updateTransferEta(actorId: string, min: string): Promise<any> {

    let body = {
      "ActorId": actorId,
      "Minutes": min
    };

    return this.http.post(this.configuration.backendUrl + "/api/bustransfer/UpdateEta", body,
      (result) => { },
      (exception) => { }).toPromise<any>();
  }

  public async updateGateStatus(gates: GateStatus[]): Promise<any> {

    let body = {
      "model": gates,
    };

    return this.http.post(this.configuration.backendUrl + "/api/bustransfer/SetStatusForGate", body,
      (result) => { },
      (exception) => { }).toPromise<any>();
  }

  public async requestTransfer(transferPoint: Location): Promise<any> {

    let body = {
      "transferPoint": transferPoint.name,
    };

    console.log("request transfer: " + transferPoint);
    return this.http.post(this.configuration.backendUrl + "/api/bustransfer/requesttransfer", body,
      (result) => { },
      (exception) => { }).toPromise<any>();
  }

  public async cancelTransfer(activityId: string): Promise<any> {

    let body = {
      "activityId": activityId
    };

    console.log("cancel transfer: " + activityId);

    return this.http.post(this.configuration.backendUrl + "/api/bustransfer/canceltransfer", body,
      (result) => { },
      (exception) => { }).toPromise<any>();
  }

  // administration bfs-maps
  public async getAllBfsMaps(): Promise<any> {

    let url: string = this.configuration.backendUrl + "/api/bfsmaps/listmaps/";

    return await this.http.get(url, () => { },
      () => { }).toPromise<any>();
  }

  public async deleteBfsMap(filename: string): Promise<any> {
    let url: string = this.configuration.backendUrl + "/api/bfsmaps/deleteMap/" + filename + "/";
    return await this.http.get(url, () => { },
      () => { }).toPromise<any>();
  }

  public async uploadBfsMap(uploadFile: any): Promise<any> {
    return this.http.put(this.configuration.backendUrl + "/api/bfsmaps/uploadfile", uploadFile,
      (result) => {
        console.log('file uploaded');
      },
      (exception) => { }).toPromise<any>();
  }

  public async getBfsMap(filename: string): Promise<any> {
    let url: string = this.configuration.backendUrl + "/api/bfsmaps/getMap/" + filename + "/";
    return await this.http.get(url, () => { },
      () => { }).toPromise<any>();
  }

  private onGatePing(gateStatus: GateStatus) {
    this.ping$.emit(gateStatus);
  }

  private onUpdateGateStaus(status: GateStatus[]) {
    this.updateGateStatus$.emit(status);
  }

}
